import { isoFileExtensionDef, msBinaryFormatsDef, msXMLFormatsDef } from '../enums.mjs';

function* chunkBuffer(buffer, chunkSize) {
    for (let i = 0; i < buffer.length; i += chunkSize) {
        yield buffer.subarray(i, i + chunkSize);
    }
}
function* chunkBufferReverse(buffer, chunkSize) {
    for (let i = buffer.length; i > 0; i -= chunkSize) {
        yield buffer.subarray(Math.max(0, i - chunkSize), i);
    }
}
async function* chunkReadableStream(stream) {
    for await (const chunk of stream) {
        yield chunk;
    }
}
const MAX_CHUNK_SIZE = 1024 * 1204;
const GENERIC_MAGIC_HEADER = "MSMAMARPCRYPT%";
const TEXT_DECODER = new TextDecoder("latin1");
async function textMatchInBinary(texts, chunker, reverse) {
    let textChunk = "";
    for await (const chunk of chunker) {
        const asciiCharCodeChunk = chunk.filter((x) => x > 31);
        if (reverse) {
            textChunk = TEXT_DECODER.decode(asciiCharCodeChunk) + textChunk;
        }
        else {
            textChunk = textChunk + TEXT_DECODER.decode(asciiCharCodeChunk);
        }
        for (const text of texts) {
            if (textChunk.includes(text))
                return text;
        }
    }
    return undefined;
}
const ENCRYPTION_CHECKS = [
    {
        exts: isoFileExtensionDef,
        isEncryptedSymbols: [GENERIC_MAGIC_HEADER],
    },
    {
        exts: msBinaryFormatsDef,
        isEncryptedSymbols: [GENERIC_MAGIC_HEADER, "EncryptedPackage", "DPB="],
    },
    {
        exts: msXMLFormatsDef,
        isEncryptedSymbols: [GENERIC_MAGIC_HEADER, "EncryptedPackage"],
    },
];
const DEFAULT_ENCRYPTION_CHECK = {
    isEncryptedSymbols: [GENERIC_MAGIC_HEADER],
};
async function isDataEncrypted(fileData, ext, { maxChunkSize = MAX_CHUNK_SIZE } = {}) {
    const checker = ENCRYPTION_CHECKS.find((check) => check.exts.includes(ext)) || DEFAULT_ENCRYPTION_CHECK;
    const { isEncryptedSymbols, reverseLookup } = checker;
    const chunkSize = Math.min(maxChunkSize, fileData.length);
    const bufferChunker = reverseLookup ? chunkBufferReverse : chunkBuffer;
    const chunker = bufferChunker(fileData, chunkSize);
    const optionFirstMatch = await textMatchInBinary(isEncryptedSymbols, chunker, reverseLookup);
    if (typeof optionFirstMatch === "string") {
        return isEncryptedSymbols.includes(optionFirstMatch);
    }
    return false;
}
async function isStreamEncrypted(stream, ext) {
    const checker = ENCRYPTION_CHECKS.find((check) => check.exts.includes(ext)) || DEFAULT_ENCRYPTION_CHECK;
    const { isEncryptedSymbols } = checker;
    const chunker = chunkReadableStream(stream);
    const optionFirstMatch = await textMatchInBinary(isEncryptedSymbols, chunker);
    if (typeof optionFirstMatch === "string") {
        return isEncryptedSymbols.includes(optionFirstMatch);
    }
    return false;
}
function isFileEncrypted(file, ext) {
    return isStreamEncrypted(file.stream(), ext);
}
function base64ToUint8Array(base64) {
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}
function isBase64Encrypted(base64, ext) {
    return isDataEncrypted(base64ToUint8Array(base64), ext);
}

export { isBase64Encrypted, isDataEncrypted, isFileEncrypted, isStreamEncrypted };
